module.exports = __webpack_public_path__ + "static/media/hybriq_210x210.7e8457d6.png";